// @flow

import React, { type Element, Fragment } from 'react'
import { Button, CardActions, Grid, Typography } from '@material-ui/core'

function NoEligibleClaims({
  patientId,
  handleCancel,
}: {
  patientId: number,
  handleCancel: () => void,
}): Element<typeof Fragment> {
  return (
    <>
      <Grid container item justify="center">
        <Typography variant="h4">No eligible claims</Typography>
      </Grid>
      <Typography>Please create a claim for this patient. </Typography>
      <Grid container item justify="center">
        <CardActions>
          <Button
            variant="contained"
            color="primary"
            href={`/patients/${patientId}/billing_records/new`}
          >
            New Claim
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </CardActions>
      </Grid>
    </>
  )
}

export default NoEligibleClaims
